import Component from '../core/Component'

const STATES = {
    ACTIVE: 'is-active',
}

export default class Service extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: [],
            images: [],
        }
    }

    prepare() {
        this.ref.items.forEach((element, index) => {
            element.addEventListener('mouseenter', this.handleItemMouseEnter)
            if (index === 0) {
                element.classList.add((STATES.ACTIVE))
            }
        })
    }

    handleItemMouseEnter = (event) => {
        const itemIndex = this.ref.items.indexOf(event.currentTarget)

        this.ref.items.forEach((element, index) => {
            element.classList.remove((STATES.ACTIVE))
            if (index === itemIndex) {
                element.classList.add((STATES.ACTIVE))
            }
        })

        this.show(itemIndex)
    }

    show(itemIndex) {
        this.ref.images.forEach((element, index) => {
            element.querySelectorAll('img').forEach(el => el.classList.toggle(STATES.ACTIVE, itemIndex === index))
        })
    }
}
